export const ERROR_REPORTING_PACKAGE_NAME = 'jiraAdminPagesIssueTypesResources';
